import React from "react";

import RBACFlag from "@/app/components/core/RBACFlag";
import StatusBadge from "@/app/components/ui/Badges/StatusBadge";
import SolidButton from "@/app/components/ui/Buttons/SolidButton";
import useScreenSize from "@/app/hooks/useScreenSize";
import { VMS_CLICK_EVENTS, VMS_SCREEN_IDS, useVMSClickLog } from "@/app/hooks/useVMSClickLog";
import { ROUTES } from "@/app/routes";
import clsx from "clsx";
import { IHeaderCustomerSearchProfileComponentProps } from "../../customer_profile_interface";
import InputSearchCustomer from "../InputSearchCustomer";

const RenderPetStatusBadges = () => {
  return (
    <div className=" justify-start sm:justify-center mt-3 sm:mt-2 items-center gap-x-4 hidden md:flex">
      <StatusBadge label="Active" statusFillClassname="fill-green-500" colorClassName="bg-green-50 text-green-600" />
      <StatusBadge label="In-Active" statusFillClassname="fill-blue-500" colorClassName="bg-blue-50 text-blue-600" />
      <StatusBadge label="Deceased" statusFillClassname="fill-red-500" colorClassName="bg-red-50 text-red-600" />
    </div>
  );
};

const HeaderCustomerSearchProfileComponent: React.FC<IHeaderCustomerSearchProfileComponentProps> = ({
  searchCustomer,
}) => {
  const { isMobile } = useScreenSize();
  const { logVMSClick } = useVMSClickLog(VMS_SCREEN_IDS.SEARCH_CUSTOMER);
  return (
    <div className=" gap-3 flex-col    bg-white opacity-100 px-3 py-0 rounded-xl flex">
      <div className=" gap-3 flex-col items-start opacity-100 px-0 py-2 border-b-[rgba(128,141,160,0.2)] border-b flex">
        <div className={clsx("w-full opacity-100 p-0 flex justify-between  items-center")}>
          <h3 className={clsx("font-semibold text-black text-left text-xs xl:text-xs 2xl:text-sm")}>
            Search Customer or Patient
          </h3>
          <RBACFlag actionId="ADD_CUSTOMER">
            <div
              className="flex"
              onClick={() => logVMSClick(VMS_CLICK_EVENTS.SEARCH_CUSTOMER_ADD_CUSTOMER_CLICK, "Add Customer")}
            >
              <SolidButton asLink href={ROUTES.ROOT.children.CUSTOMER_PROFILE.children.ADD_CUSTOMER.url} size="XL">
                <span className="text-[10px] md:text-xs 2xl:text-sm">+ Add Customer</span>
              </SolidButton>
            </div>
          </RBACFlag>
        </div>
        <div className={clsx("w-full", isMobile ? "block" : "flex justify-between items-center")}>
          <InputSearchCustomer searchCustomer={searchCustomer} />
          <RenderPetStatusBadges />
        </div>
      </div>
    </div>
  );
};

export default HeaderCustomerSearchProfileComponent;
